import { ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../constants/endpoints';
import { IntensiveGlycemicMeasurementResponse, IntensiveGlycemicResponse } from './glycemic-types';

class GlycemicIntensiveService {

  static TOAST_ID = 'CALCULATE_INTENSIVE_LEVELS_TOAST_IDENTIFY'

  static calculateIntensiveLevels(encounterNumber: string | number, scheduleSequenceNumber: number, glycemicLevel: number): Promise<IntensiveGlycemicResponse> {
    const emptyResponse: IntensiveGlycemicResponse = { suggestion: '' };
    const body = {
      amount: glycemicLevel,
      encounterNumber,
      scheduleSequenceNumber,
    };

    return HttpService.post<IntensiveGlycemicResponse>(Endpoint.EMAR_POST_INTENSIVE_GLYCEMIC_LEVELS, {}, { body })
      .then(response => {
        if (!response.body) {
          return Promise.resolve(emptyResponse);
        }
        response.body.suggestion = response.body.suggestion || 'text.glycemic-level-non-action'

        return Promise.resolve(response.body);
      })
      .catch(error => {
        if(error.body?.errors.length > 0) {
          const messages = error.body?.errors;
          this.showToast(messages.join(', '));
        }
        return Promise.reject(error);
      });
  }

  static getMeasurementPerformed(scheduleSequenceNumber: number): Promise<IntensiveGlycemicMeasurementResponse | undefined> {
    return HttpService.get<IntensiveGlycemicMeasurementResponse>(Endpoint.EMAR_GET_INTENSIVE_IS_MEASUREMENT_PERFORMED, { scheduleSequenceNumber })
      .then(response => Promise.resolve(response.body));
  }

  static confirmIntensivePerformation(scheduleSequenceNumber: number): Promise<void> {
    const body = {
      scheduleSequenceNumber
    };

    return HttpService.post(Endpoint.EMAR_GET_CONFIRM_INTENSIVE_PERFORMATION, undefined, { body })
      .then(() => Promise.resolve())
      .catch(error => {
        if(error.body?.errors.length > 0) {
          const messages = error.body?.errors;
          this.showToast(messages.join(', '));
        }
        return Promise.reject();
      });
  }

  private static showToast(message: string): void {
    ToastService.open({
      dismissible: true,
      id: this.TOAST_ID,
      level: ToastLevel.WARNING,
      message,
      showIcon: true,
      timeout: 7000,
      type: ToastType.BUBBLE,
    });
  }
}

export default GlycemicIntensiveService;
